export default __webpack_public_path__ + "static/media/animate-delivery-red.54ba634e.gif";